import React from 'react';
import { useTheme } from '../../theme';
import SectionLabel from '../shared/SectionLabel';

const entries = [
  { who: 'june_t', when: '2026-04-11', note: "lost touch after college. i miss you, hope you're well. mary still asks about you sometimes.", relation: 'they know you from steam, 2017–2019' },
  { who: 'theo_l', when: '2025-11-02', note: 'the apartment in echo park. that game we never finished. hi.', relation: 'they know you from discord, 2020' },
];

export default function SampleTagPage() {
  const { p, d, fonts } = useTheme();

  return (
    <section style={{ padding: `${d.hero}px ${d.pad}px`, borderBottom: `1px solid ${p.border}` }}>
      <div style={{ maxWidth: 1180, margin: '0 auto' }}>
        <SectionLabel>§ 02 / what a result looks like</SectionLabel>
        <h2 style={{
          fontFamily: fonts.serif, fontSize: 56, fontWeight: 400, letterSpacing: '-.025em',
          lineHeight: 1.04, color: p.textHi, margin: '0 0 14px', maxWidth: 840,
        }}>
          The page someone sees when<br />
          <span style={{ fontStyle: 'italic', color: p.text }}>they search their own old name.</span>
        </h2>
        <p style={{
          fontFamily: fonts.sans, fontSize: d.body + 1, color: p.text, lineHeight: 1.55,
          maxWidth: 620, margin: '0 0 56px',
        }}>
          A clean record of who's been looking, what they remembered, and a private way to write back. Or one click to take it down. No login required.
        </p>

        <div style={{
          background: p.bgPanel, border: `1px solid ${p.border}`,
          fontFamily: fonts.mono, color: p.text, maxWidth: 980, margin: '0 auto',
        }}>
          <div style={{
            padding: '12px 22px', borderBottom: `1px solid ${p.border}`,
            display: 'flex', justifyContent: 'space-between',
            fontSize: 11, color: p.textDim, letterSpacing: '.06em',
          }}>
            <span>/ index / steam / kestrel_99</span>
            <span>indexed 2024-08-12 · 2 records</span>
          </div>

          <div style={{
            padding: '32px 28px 24px', display: 'grid',
            gridTemplateColumns: '1fr auto', alignItems: 'baseline', gap: 24,
          }}>
            <div>
              <div style={{ fontSize: 11, color: p.textDim, letterSpacing: '.12em', marginBottom: 8 }}>STEAM · USERNAME</div>
              <div style={{ fontFamily: fonts.mono, fontSize: 38, color: p.textHi, fontWeight: 500, letterSpacing: '-.01em' }}>
                kestrel_99
              </div>
              <div style={{ marginTop: 8, fontSize: 12.5, color: p.textDim }}>
                last seen online: <span style={{ color: p.text }}>11 months ago</span> · profile public
              </div>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <span style={{ padding: '10px 16px', border: `1px solid ${p.border}`, color: p.text, fontSize: 12, letterSpacing: '.04em' }}>NOT ME</span>
              <span style={{ padding: '10px 16px', background: p.accent, color: p.bg, fontSize: 12, fontWeight: 600, letterSpacing: '.04em' }}>THIS IS ME ↵</span>
            </div>
          </div>

          <div style={{ padding: '0 28px', borderTop: `1px dashed ${p.border}` }}>
            {entries.map((t, i) => (
              <div key={i} style={{
                padding: '24px 0',
                borderBottom: i < entries.length - 1 ? `1px dashed ${p.border}` : 'none',
                display: 'grid', gridTemplateColumns: '140px 1fr', gap: 24,
              }}>
                <div>
                  <div style={{ fontSize: 11, color: p.textDim, letterSpacing: '.06em' }}>RECORD #{i + 1}</div>
                  <div style={{ fontSize: 13, color: p.text, marginTop: 6 }}>{t.who}</div>
                  <div style={{ fontSize: 11, color: p.textFaint, marginTop: 4 }}>{t.when}</div>
                </div>
                <div>
                  <div style={{
                    fontFamily: fonts.serif, fontSize: 21, fontStyle: 'italic', color: p.textHi,
                    lineHeight: 1.4, fontWeight: 400, letterSpacing: '-.005em',
                  }}>
                    "{t.note}"
                  </div>
                  <div style={{ marginTop: 10, fontSize: 11.5, color: p.textDim, letterSpacing: '.04em' }}>
                    ↳ {t.relation}
                  </div>
                  <div style={{ marginTop: 18, display: 'flex', gap: 8 }}>
                    <span style={{ padding: '7px 14px', border: `1px solid ${p.borderHi}`, fontSize: 11.5, color: p.text, letterSpacing: '.04em' }}>WRITE BACK</span>
                    <span style={{ padding: '7px 14px', fontSize: 11.5, color: p.textDim, letterSpacing: '.04em' }}>REMOVE THIS RECORD</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div style={{
            padding: '14px 28px', background: p.bg, borderTop: `1px solid ${p.border}`,
            display: 'flex', justifyContent: 'space-between', fontSize: 11, color: p.textDim, letterSpacing: '.06em',
          }}>
            <span>nothing in this record is public until you sign in</span>
            <span>↑ remove all & opt out</span>
          </div>
        </div>
      </div>
    </section>
  );
}
